var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrikerFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6425 1.42981H2.77517C1.86655 1.42981 1.10924 2.17808 1.33372 3.05792C1.5727 3.99029 2.01292 4.85903 2.62348 5.60311C3.23403 6.3472 4.00009 6.94857 4.86786 7.365C5.54459 7.68897 6.06427 8.32542 6.06427 9.07533V14.0781C6.06435 14.2182 6.10022 14.3559 6.16849 14.4783C6.23676 14.6006 6.33516 14.7035 6.45436 14.7772C6.57355 14.8508 6.70959 14.8928 6.84955 14.8991C6.98952 14.9054 7.12877 14.8758 7.25411 14.8132L8.89866 13.9909C9.03522 13.9227 9.15009 13.8177 9.2304 13.6879C9.31071 13.5581 9.3533 13.4084 9.35338 13.2558V9.07533C9.35338 8.32542 9.87306 7.68897 10.549 7.365C11.4171 6.94881 12.1835 6.34753 12.7943 5.60343C13.4052 4.85933 13.8456 3.99047 14.0848 3.05792C14.3076 2.17808 13.5495 1.42981 12.6425 1.42981Z",
    stroke: "#006AB3",
    strokeWidth: 1.64455
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikerFilterIcon);
export default __webpack_public_path__ + "static/media/strikerFilterIcon.9822fd886b0aea8ffe8c1f6578200e22.svg";
export { ForwardRef as ReactComponent };